import { useState, useEffect, useCallback } from 'react'
import { changelog, LAST_SEEN_VERSION_KEY } from '@/lib/changelog'

export function useChangelog() {
  const [showChangelog, setShowChangelog] = useState(false)

  useEffect(() => {
    const lastSeen = localStorage.getItem(LAST_SEEN_VERSION_KEY)
    if (lastSeen === null) {
      // First install — mark as seen without showing
      localStorage.setItem(LAST_SEEN_VERSION_KEY, changelog.version)
      return
    }
    if (lastSeen !== changelog.version) {
      setShowChangelog(true)
    }
  }, [])

  const dismissChangelog = useCallback(() => {
    localStorage.setItem(LAST_SEEN_VERSION_KEY, changelog.version)
    setShowChangelog(false)
  }, [])

  return { showChangelog, dismissChangelog }
}
